import Vue from 'vue'
Vue.filter('filterNumberFn', function(val,num){
    return Number(val).toFixed(num);
})
Vue.filter('MilestoneDataV2Fn', function(val){
  const week = new Date(val).getDay();
  const date = new Date(val).getDate();
  const month = new Date(val).getMonth();
  const year = new Date(val).getFullYear();
  const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const weekArr = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  return `${monthArr[month]} ${date} ${year}, ${weekArr[week - 1]}`
})
